import { BeneficiaryFilterBooleanType } from '@repo/shared/dtos/beneficiary'
import { BooleanSchemaItem } from '@repo/shared/dtos/structured-data'
import { useT } from '@repo/ui/hooks'

import BooleanFilterForm from './BooleanFilterForm'
import { FilterWrapper } from './FilterWrapper'
import { FilterProps } from './types'

export default function BooleanFilter(
  props: FilterProps<BeneficiaryFilterBooleanType, BooleanSchemaItem>,
) {
  const { t } = useT({ keyPrefix: 'beneficiary.filters' })
  const optionalsCrushed = { value: t(`boolean.${props.filter.value}`) }
  if (props.readonly) return <FilterWrapper {...props} optionalsCrushed={optionalsCrushed} />
  return (
    <FilterWrapper
      {...props}
      optionalsCrushed={optionalsCrushed}
      renderForm={(onCancel) => (
        <BooleanFilterForm filter={props.filter} onChange={props.onChange} onCancel={onCancel} />
      )}
    />
  )
}
